import http from '@/plugins/axios/axios';

export default class UsuarioIKAcessoService {

    constructor() {
        this.baseUrl = process.env.VUE_APP_BASE_URL_ADMIN_IKACESSO;
    }

    listar() {
        return http.request({
            method: 'get',
            withCredentials: true,
            url: this.baseUrl + '/api/admin/v1'
        });
    }

    salvar(requisicao) {
        return http.request({
            method: 'post',
            withCredentials: true,
            url: this.baseUrl + '/api/admin/v1',
            data: requisicao
        });
    }

    ativar(id) {
        return http.request({
            method: 'put',
            withCredentials: true,
            url: this.baseUrl + '/api/admin/v1/ativar/' + id
        });
    }

    desativar(id) {
        return http.request({
            method: 'put',
            withCredentials: true,
            url: this.baseUrl + '/api/admin/v1/desativar/' + id
        });
    }

    excluir(id) {
        return http.request({
            method: 'delete',
            withCredentials: true,
            url: this.baseUrl + '/api/admin/v1/' + id
        });
    }

}